import axios from 'axios'
import { getExternalReference } from '../getExternalReference'

export interface GenerateFromDescriptionResponse {
  job_id: string
  generation_id: number
  project_id: number
  frontend_id: string
  status: 'QUEUED' | 'PROCESSING'
  type: 'create_unit_from_description'
}

export interface GenerateFromDescriptionStatusResponse {
  job_id: string
  status: 'QUEUED' | 'PROCESSING' | 'COMPLETED' | 'ENDED'
  snapshot?: import('../../types/createUnitPrefill').CreateUnitPrefillSnapshot
}

const getAuthHeaders = () => {
  const token = localStorage.getItem('@realize: accessToken')
  if (!token) {
    return null
  }
  return { Authorization: `Bearer ${token}` }
}

export const generateFromDescription = async (
  description: string,
  locale = 'pt-BR'
): Promise<GenerateFromDescriptionResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const headers = getAuthHeaders()
    if (!headers) {
      console.error('No authorization token found')
      return null
    }

    const formData = new FormData()
    formData.append('description', description)
    formData.append('locale', locale)
    formData.append('external_reference', getExternalReference(backendUrl))

    const response = await axios.post(
      `${backendUrl}/n8n/mavis/corporate/generate-from-description`,
      formData,
      { headers }
    )

    return (response.data as unknown) as GenerateFromDescriptionResponse
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}

export const getGenerateFromDescriptionStatus = async (
  jobId: string
): Promise<GenerateFromDescriptionStatusResponse | null> => {
  try {
    const backendUrl = process.env.REACT_APP_BACKEND

    if (!backendUrl) {
      console.error('REACT_APP_BACKEND environment variable is not defined')
      return null
    }

    const headers = getAuthHeaders()
    if (!headers) {
      console.error('No authorization token found')
      return null
    }

    const response = await axios.get(
      `${backendUrl}/n8n/mavis/corporate/generate-from-description`,
      {
        params: { job_id: jobId },
        headers
      }
    )

    return (response.data as unknown) as GenerateFromDescriptionStatusResponse
  } catch (error) {
    console.error('Unexpected error:', error)
    return null
  }
}
